"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendService = void 0;
var descriptors_1 = require("./descriptors");
/**
 * 将模块动态添加到已经初始化完成的DI容器
 * @param instantiation  目标DI容器
 * @param id 模块ID
 * @param ctor 模块构造函数
 * @param staticArguments 模块静态参数
 * @param supportsDelayedInstantiation 是否支持延迟初始化
 */
function appendService(instantiation, id, ctor, staticArguments, supportsDelayedInstantiation) {
    instantiation.addService(id, new descriptors_1.SyncDescriptor(ctor, staticArguments, supportsDelayedInstantiation));
}
exports.appendService = appendService;
//# sourceMappingURL=service-appender.js.map